<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <CustomIcon :name="content.image" class="card-logo small" />
        <h1 class="card-header-title">{{ content.title }}</h1>
        <p>
          {{ content.description }}
        </p>
      </div>
      <div :class="categorySetClass()">
        <ProgramCategory
          v-for="(item, index) in content.options"
          :key="`${index}-${item.label}`"
          :title="item.text"
          :image="item.icon"
          :description="item.description"
        />
      </div>
      <CustomButton variation="primary" :onClick="action">
        {{ content.continue_button_label }}
      </CustomButton>
    </div>
  </div>
</template>
<script>
import CustomButton from "@/components/CustomButton.vue";
import CustomIcon from "@/components/CustomIcon.vue";
import ProgramCategory from "@/components/ProgramCategory.vue";
import classnames from "classnames";

export default {
  components: {
    CustomButton,
    CustomIcon,
    ProgramCategory,
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        description: String,
        image: String,
        options: {
          type: Array,
          default: () => [
            {
              id: String,
              label: String,
              to: String,
              icon: String,
              text: String,
              description: String,
              isActive: Boolean,
              target_field: String,
              value: [String, Boolean, Array],
            },
          ],
        },
      }),
    },
  },
  methods: {
    categorySetClass() {
      const className = "category-set";

      return classnames(className, {
        ["is-multi-option"]: this.content.options.length > 1,
      });
    },
  },
};
</script>
